export default (Api) => {
  return {
    authenticated: false,
    userData: null,
    projectData: null,
    avaibleProjects: null,
    async checkLogin() {
      const response = await Api.checkLogin()
      this.authenticated = response.status
      this.setAuthData(response.user)
      this.setProjectData(response.project)
      await this.checkProjects()
      return response
    },
    async login(data) {
      const response = await Api.login(data)
      this.authenticated = response.status
      this.setAuthData(response.user)
      this.setProjectData(response.project)
      await this.checkProjects()
      return response
    },
    async loginHash(hash) {
      const response = await Api.send("get", `/auth/registerSystem/${hash}`)
      this.authenticated = response.status
      this.setAuthData(response.user)
      this.setProjectData(response.project)
      await this.checkProjects()
      return response
    },
    async logout() {
      this.authenticated = false
      delete this.userData
      const response = await Api.logout()
      return response
    },
    setAuthData(data) {
      this.userData = data
    },
    setProjectData(data) {
      this.projectData = data
      if (data && data.fileUrl)
        Api.createFileHttp(data.fileUrl)
    },
    check(permition) {
      return permition & this.userData.permissions
    },
    async checkProjects() {
      if (this.avaibleProjects !== null) return;
      const response = await Api.send("get", "/projects")
      if (response.status)
        this.avaibleProjects = response.projects
    },
  }
}